import React, { useState, useEffect, useRef } from "react";
import "./CareerMainSection.css";
import { getPostJobWeb, hiringApplicants, imageUploadCareerHiring } from "../../api/api";
import toast from "react-hot-toast";
// import img1 from "../../Assets/career/vacancie.jpg"
import img1 from "../../Assets/career/vacancie.jpg"
import img2 from "../../Assets/career/we do.jpg"
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";

export default function CareerMainSection() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openJobId, setOpenJobId] = useState(null);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [cvUploading, setCvUploading] = useState({});
  const positionsRef = useRef(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");


  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState({ type: "", title: "", data: null });

  useEffect(() => {
    fetchJobs();
  }, []);


  const fetchJobs = async () => {
    try {
      const res = await getPostJobWeb({});
      if (res?.data?.status === "success") {
        setJobs(res.data.data || []);
      } else {
        toast.error("Unable to load job openings");
      }
    } catch (err) {
      console.error("Error fetching jobs:", err);
      toast.error("Unable to connect to server");
    }
  };

  const toggleJobDetails = (id) => {
    setOpenJobId(openJobId === id ? null : id);
  };

  const handleChange = (e, jobId) => {
    if (e.target.name === "mobile") {
      e.target.value = e.target.value.replace(/\D/g, "");
    }
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [jobId]: {
        ...prev[jobId],
        [name]: value,
      },
    }));

    setErrors((prev) => ({
      ...prev,
      [jobId]: {
        ...prev[jobId],
        [name]: "",
      },
    }));
  };

  // const handleFileChange = async (e, jobId) => {
  //   const file = e.target.files[0];
  //   if (!file) {
  //     setCvUploading((prev) => ({ ...prev, [jobId]: false }));
  //     return;
  //   }

  //   if (file.type !== "application/pdf") {
  //     setErrors((prev) => ({
  //       ...prev,
  //       [jobId]: { ...prev[jobId], cv: "Only PDF files are allowed" },
  //     }));
  //     return;
  //   }

  //   setCvUploading((prev) => ({ ...prev, [jobId]: true }));

  //   try {
  //     const formDataCV = new FormData();
  //     formDataCV.append("uploadImage", file);

  //     const res = await imageUploadCareerHiring(formDataCV);

  //     if (res?.data?.status === "Success" && res?.data?.uploadImage?.uploadImage) {
  //       const uploadedUrl = res.data.uploadImage.uploadImage;

  //       setFormData((prev) => ({
  //         ...prev,
  //         [jobId]: {
  //           ...prev[jobId],
  //           cvUrl: uploadedUrl,
  //         },
  //       }));

  //       setErrors((prev) => ({
  //         ...prev,
  //         [jobId]: {
  //           ...prev[jobId],
  //           cv: "",
  //         },
  //       }));

  //       toast.success("CV uploaded successfully!");
  //     } else {
  //       throw new Error("Unexpected response from server");
  //     }
  //   } catch (err) {
  //     console.error("Error uploading CV:", err);
  //     toast.error("Failed to upload CV. Please try again.");
  //     setErrors((prev) => ({
  //       ...prev,
  //       [jobId]: { ...prev[jobId], cv: "Upload failed" },
  //     }));
  //   } finally {
  //     setCvUploading((prev) => ({ ...prev, [jobId]: false }));
  //   }
  // };

  const validateForm = (data) => {
    const errors = {};

    if (!data.fullName || !data.fullName.trim()) {
      errors.fullName = "Full name is required";
    } else if (!/^[A-Za-z\s]+$/.test(data.fullName.trim())) {
      errors.fullName = "Name can contain only letters and spaces";
    }

    if (!data.email || !data.email.trim()) {
      errors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email.trim())) {
      errors.email = "Invalid email format";
    }

    if (!data.mobile) {
      errors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(data.mobile)) {
      errors.mobile = "Mobile number must be exactly 10 digits";
    }

    if (!data.cvUrl) {
      errors.cv = "Please upload your CV";
    }

    return errors;
  };


  
  const cards = [
    {
      title: "Why Join Us?",
      image: img2,
      type: "whyJoin",
      content: {
        paragraphs: [
          
          <b>Job Stability & Long-Term Growth:-</b>,
          "Opportunity to grow with a well-established and expanding diagnostic network.",

          <b>Professional Work Environment:-</b>,
          "Structured processes, ethical practices, and a respectful workplace culture.",

          <b>Exposure to Advanced Technology:-</b>,
          "Hands-on experience with modern diagnostic equipment and updated protocols.",

          <b>Learning & Skill Development:-</b>,
          "Continuous learning through case exposure, training, and interaction with senior doctors and specialists.",

          <b>Work–Life Balance:-</b>,
          "Planned shifts, fair duty hours, and operational support to reduce work pressure.",

          <b>Multidisciplinary Team Experience:-</b>,
          "Work closely with radiologists, pathologists, technicians, clinicians, and support staff.",


          <b>Employee Health Benefits:-</b>,
          "Discounted diagnostic services for employees and their immediate family.",

          <b>Opportunities Across Locations</b>,
          "Internal transfer opportunities within branches as the organization expands.",

          <b>Safe & Supportive Workplace:-</b>,
          "Strong focus on hygiene, safety standards, and patient-friendly operations.Competitive Salary & Timely Payments  Transparent payout structure with on-time salary disbursement.",




        ],
        benefits: [         
          // "Internal transfer opportunities within branches as the organization expands.",
        ]
      }
    },
    {
      title: "Current Vacancies",
      image: img1,
      type: "vacancies",
      content: null
    },
  ];

  // Why Join Us Modal Content
  const WhyJoinUsModal = () => (
    <div className="why-join-modal">
      <h3>Why Join Our Team?</h3>
      <div className="modal-content">
        <div className="paragraphs-section">
          <h4>What We Offer:</h4>
          {modalContent.data.paragraphs.map((para, index) => (
            <p key={index} className="paragraph">{para}</p>
          ))}
        </div>

        <div className="benefits-section">
          {/* <h4>Benefits & Perks:</h4>*/}
          <ul className="benefits-list">
            {modalContent.data.benefits.map((benefit, index) => (
              <li key={index} className="benefit-item">
                <span className="check-icon">✓</span> {benefit}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );

  // Job Application Modal
  const JobApplicationModal = () => {
    const [localFormData, setLocalFormData] = useState({
      fullName: "",
      email: "",
      mobile: "",
      cv: null,
      cvUrl: "",
      comment: ""
    });


    useEffect(() => {
      if (modalContent?.data?.jobTitle) {
        setLocalFormData(prev => ({
          ...prev,
          comment: `Applying for: ${modalContent.data.jobTitle}`
        }));
      }
    }, [modalContent]);


    const [localErrors, setLocalErrors] = useState({});
    const [uploading, setUploading] = useState(false);
    const [submitting, setSubmitting] = useState(false);




    const handleLocalFileChange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      if (file.type !== "application/pdf") {
        setLocalErrors(prev => ({ ...prev, cv: "Only PDF files are allowed" }));
        return;
      }

      setUploading(true);
      try {
        const formDataCV = new FormData();
        formDataCV.append("uploadImage", file);

        const res = await imageUploadCareerHiring(formDataCV);

        if (res?.data?.status === "Success" && res?.data?.uploadImage?.uploadImage) {
          setLocalFormData(prev => ({
            ...prev,
            cv: file,
            cvUrl: res.data.uploadImage.uploadImage
          }));
          setLocalErrors(prev => ({ ...prev, cv: "" }));
          toast.success("CV uploaded successfully!");
        }
      } catch (err) {
        toast.error("Failed to upload CV");
        setLocalErrors(prev => ({ ...prev, cv: "Upload failed" }));
      } finally {
        setUploading(false);
      }
    };

    const handleLocalSubmit = async (e) => {
      e.preventDefault();

      const errorsFound = validateForm(localFormData);

      if (Object.keys(errorsFound).length > 0) {
        setLocalErrors(errorsFound);
        return; // ❗ STOP SUBMISSION
      }

      setLocalErrors({}); // clear old errors

      const payload = {
        careerHiringsID: modalContent.data.careerHiringsID,
        jobPost: modalContent.data.jobTitle,
        name: `${localFormData.firstName} ${localFormData.lastName}`,
        mobile: localFormData.mobile,
        email: localFormData.email,
        imageCv: localFormData.cvUrl,
        comment: localFormData.comment || ""
      };

      try {
        setSubmitting(true);
        const res = await hiringApplicants(payload);
        console.log("test data", res);
        if (res?.data?.status === "success") {
          toast.success(res?.data?.message);

          { successMessage && <p className="success-text">{successMessage}</p> }
          { errorMessage && <p className="error-text">{errorMessage}</p> }


          setLocalFormData({
            firstName: "",
            lastName: "",
            email: "",
            mobile: "",
            cv: null,
            cvUrl: "",
            comment: ""
          });
          setLocalErrors({});
          setOpenModal(false);
        } else {
          toast.error("Something went wrong");
        }
      } catch (err) {
        toast.error("Server error");
      } finally {
        setSubmitting(false);
      }
    };
    return (
      <div className="job-application-modal">
        <h3>Application for {modalContent.data.jobTitle}</h3>

        <form onSubmit={handleLocalSubmit} className="apply-form">
         
          <input
            type="text"
            placeholder="Full Name"
            value={localFormData.fullName}
            onChange={(e) => {
              const value = e.target.value.replace(/[^A-Za-z\s]/g, "");
              setLocalFormData(prev => ({ ...prev, fullName: value }));
              setLocalErrors(prev => ({ ...prev, fullName: "" }));
            }}
          />

          {localErrors.fullName && (
            <span className="error-text">{localErrors.fullName}</span>
          )}

 {/* {localErrors.firstName && <span className="error-text">{localErrors.firstName}</span>} */}
          {/* 
        <input
          type="text"
          placeholder="Last Name"
          value={localFormData.lastName}
         onChange={(e) => {
  const value = e.target.value.replace(/[^A-Za-z\s]/g, "");
  setLocalFormData(prev => ({ ...prev, lastName: value }));
  setLocalErrors(prev => ({ ...prev, lastName: "" }));
}}

        />
        {localErrors.lastName && <span className="error-text">{localErrors.lastName}</span>} */}

          <input
            type="email"
            placeholder="Email"
            value={localFormData.email}
            onChange={(e) =>
              setLocalFormData(prev => ({ ...prev, email: e.target.value }))
            }
          />
          {localErrors.email && <span className="error-text">{localErrors.email}</span>}

          <input
            type="tel"
            placeholder="Mobile (10 digits)"
            value={localFormData.mobile}
            maxLength="10"
            onChange={(e) =>
              setLocalFormData(prev => ({
                ...prev,
                mobile: e.target.value.replace(/\D/g, "")
              }))
            }
          />
          {localErrors.mobile && <span className="error-text">{localErrors.mobile}</span>}

          <input type="file" accept=".pdf" onChange={handleLocalFileChange} />
          {uploading && <p>Uploading...</p>}
          {localErrors.cv && <span className="error-text">{localErrors.cv}</span>}

          <button type="submit" disabled={uploading || submitting}>
            {submitting ? "Submitting..." : "Submit Application"}
          </button>
        </form>
      </div>
    );
  };

  // Common Modal Component
  const Modal = () => {
    if (!openModal) return null;

    return (
      <div className="modal-overlay">
        <div className="modal">
          <span className="modal-close" onClick={() => setOpenModal(false)}>
            ✕
          </span>

          {modalContent.type === "whyJoin" && <WhyJoinUsModal />}
          {modalContent.type === "application" && <JobApplicationModal />}
        </div>
      </div>
    );
  };

  // JobListings Section
  const JobListings = () => {
    

    const jobdescription = () => {
      console.log("button is working");
    }

    return (
      <section className="jobs-section" ref={positionsRef}>
        <h2 className="section-title">Current Job Openings</h2>
        <p className="section-subtitle">Explore our available positions and apply today!</p>
        <div className="jobs-container">
          {jobs.map((job, i) => (
            <div className="job-card" key={i}>
              <h1 className="job-title">{job.jobTitle}
 <h6>
                      Experience: {job.experience} Yr |   No. Of Vacancies:{" "}
                      {job.vacancies}
                    </h6>
                 
              </h1>

        
              {/* <p className="job-department">
                Department: {job.dept}
              </p> */}
              <p className="job-description">{job.desc}</p>
              {/*change*/}
              {/* <div className="job-left">
                      <h3>Location</h3>
                      <p>
                        {job.centerList?.length > 0
                          ? job.centerList.map((c) => c.center_name.trim()).join(", ")
                          : "Location not specified"}
                      </p>

                      <h3>Description</h3>
                      <div
                        className="job-description"
                        dangerouslySetInnerHTML={{ __html: job.description }}
                      />

                      <h3>Skills</h3>
                      <div
                        className="job-skills"
                        dangerouslySetInnerHTML={{ __html: job.skills }}
                      />
                    </div>  */}

              {/*Change*/}

              {/* 
               <div className="job-actions">
                <button
  className="btn-outline"
  onClick={() =>
    setOpenJobId(openJobId === job.id ? null : job.id)
  }
>
  Job Description
</button> */}


              {/* <button
                  className="btn-primary"
                  onClick={() => {
                    setModalContent({
                      type: "application",
                      title: job.jobTitle,
                      data: job
                    });
                    setOpenModal(true);
                  }}
                >
                  Apply Now
                </button> */}

              <button
                className="urgent-btn"
                onClick={() => toggleJobDetails(job.careerHiringsID)}
              >
                {openJobId === job.careerHiringsID ? <IoIosArrowUp /> : <IoIosArrowDown />}
              </button>
              
              {openJobId === job.careerHiringsID && (

                <div className="job-expanded">
                  <div className="job-details-left">
                    {/* <h3>Location: </h3> */}
                    <h3>Location: </h3>
                    <p><strong>{job.centerList?.map((item) => item.center_name).join(", ")}</strong></p>

                    {/* <h3>Description</h3>
                    <div dangerouslySetInnerHTML={{ __html: job.description }} /> */}

                    {/* <h3>Skills</h3>
                    <div dangerouslySetInnerHTML={{ __html: job.skills }} /> */}
                    {/* <h3>Responsibilities</h3>
                    <div dangerouslySetInnerHTML={{ __html: job.responsibilities }} /> */}
                    {/* <h3>No of Vacancy</h3>
                     <div dangerouslySetInnerHTML={{ __html: job.experience }} />*/}
<div className="job-actions">
<button
  className="btn-outline"
  onClick={() => {
    const pdfLink = job?.pdfLink?.trim();
    if (pdfLink) {
      window.open(pdfLink, "_blank", "noopener,noreferrer");
    }
  }}
>
  Job Description
</button>

   <button
                  className="btn-primary"
                  onClick={() => {
                    setModalContent({
                      type: "application",
                      title: job.title,
                      data: job
                    });
                    setOpenModal(true);
                  }}
                >
                  Apply Now
                </button>

</div>
                  </div> 

                  <div className="job-apply-box">
                    {/* your apply form here */}
                  </div>
                </div>
              )}

               {/* <div className="job-actions">
                <button
                  className="btn-outline"
                  onClick={() =>
                    setOpenJobId(
                      openJobId === job.careerHiringsID ? null : job.careerHiringsID
                    )
                  }
                >
                  Job Description
                </button>   */}
                {/* <button
                  className="btn-outline"
                  onClick={() => {
                    const pdfLink = job?.pdfLink?.trim();

                    if (pdfLink) {
                      // ✅ If PDF exists → open PDF
                      window.open(pdfLink, "_blank");
                    }
                    // } else {
                    //   // ✅ If PDF missing → expand text (old behavior)
                    //   setOpenJobId(
                    //     openJobId === job.careerHiringsID
                    //       ? null
                    //       : job.careerHiringsID
                    //   );
                    // }
                  }}
                >
                  Job Description
                </button> */}
{/* <button
  className="btn-outline"
  onClick={() => {
    const pdfLink = job?.pdfLink?.trim();
    if (pdfLink) {
      window.open(pdfLink, "_blank", "noopener,noreferrer");
    }
  }}
>
  Job Description
</button>

   <button
                  className="btn-primary"
                  onClick={() => {
                    setModalContent({
                      type: "application",
                      title: job.title,
                      data: job
                    });
                    setOpenModal(true);
                  }}
                >
                  Apply Now
                </button> */}
                {/* 
<button
  className="btn-primary"
  onClick={() => {
    setModalContent({
      type: "application",
      title: job.jobTitle,
      data: job
    });
    setOpenModal(true);
  }}
>
  Apply Now
</button> */}
</div>
          ))}
        </div>
      </section>
    );

  }
  return (
    <div className="career-body">
      <section className="hero-section">
        <h1 className="rb-title">Career</h1>
       
      </section>

      {/* Career Cards Section */}
      <section className="career-cards-section">
        <div className="career-cards-container">
          <div className="career-cards-grid">
            {cards.map((card, index) => (
              <div
                key={index}
                className="career-card"
                onClick={() => {
                  if (card.type === "whyJoin") {
                    setModalContent({
                      type: "whyJoin",
                      title: card.title,
                      data: card.content
                    });
                    setOpenModal(true);
                  } else if (card.type === "vacancies") {
                    positionsRef.current?.scrollIntoView({ behavior: "smooth" });
                  }
                }}
              >
                <img
                  src={card.image}
                  alt={card.title}
                  className="career-card-image"
                />
                <div className="career-card-overlay" />
                <div className="career-card-content">
                  <h3 className="career-card-title">
                    {card.title}
                  </h3>
                  <p className="card-click-hint">Click to {card.type === "whyJoin" ? "learn more" : "view vacancies"}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* JobListings Section */}
      <JobListings />

      {/* Modal */}
      <Modal />
    </div>
  )
}